import { Injectable } from '@angular/core';

interface RuntimeConfig {
  apiUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: RuntimeConfig = { apiUrl: '' };

  get apiUrl(): string {
    return this.config.apiUrl;
  }

  async load(): Promise<void> {
    try {
      // When running locally, prefer dev config to connect to AWS DEV backend
      const isLocalhost =
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1');
      const configPath = isLocalhost
        ? '/runtime-config.dev.json'
        : '/runtime-config.json';
      const cacheBust = `v=${Date.now()}`;
      const response = await fetch(`${configPath}?${cacheBust}`);
      if (response.ok) {
        const loaded = await response.json();
        if (loaded.apiUrl && !loaded.apiUrl.includes('REPLACE_WITH')) {
          this.config = loaded;
        } else if (isLocalhost) {
          // Dev config has placeholder; fall back to prod
          const fallback = await fetch(`/runtime-config.json?${cacheBust}`);
          if (fallback.ok) {
            this.config = await fallback.json();
          }
        } else {
          this.config = loaded;
        }
      }
    } catch {
      console.warn('Runtime config not found, using defaults');
    }
  }
}
